module.exports = __webpack_public_path__ + "img/baoxian02.d20f1cfe.png";